import axiosInstance from "./axiosInstance";
import API from "../constants/api.constant";

export type ContactUsPayload = {
  name: string;
  email: string | undefined;
  phone?: string;
  subject?: string;
  message: string;
};

export type DemoRequestPayload = {
  firstName: string;
  lastName: string;
  middleName: string;
  email: string | undefined;
  phone?: string;
  companyName?: string;
  message?: string;
  role: string;
};

export type WaitlistPayload = {
  firstName: string;
  lastName: string;
  middleName: string;
  email: string | undefined;  
  companyName?: string;
  role: string;
  dealsPerMonth?: string;
};

const createContactUs = async (payload: ContactUsPayload) => {
  const response = await axiosInstance.post(API.LANDING_CONTACT_US, payload);
  return response.data;
};

const createDemoRequest = async (payload: DemoRequestPayload) => {
  const response = await axiosInstance.post(API.LANDING_DEMO_REQUEST, payload);
  return response.data;
};

const joinWaitlist = async (payload: WaitlistPayload) => {
  const response = await axiosInstance.post(API.LANDING_WAITLIST, payload);
  return response.data;
};

export { createContactUs, createDemoRequest, joinWaitlist };
